import { useEffect, useState } from 'react';
import { Input } from '@chakra-ui/react';
import useDebounce from '../../helpers/useDebounce';

const DebounceInput = ({ onChange, ...inputProps }) => {
  const [value, setValue] = useState('');
  const debouncedSearch = useDebounce((v) => onChange(v));

  useEffect(() => {
    debouncedSearch(value);
  }, [value]);

  return (
    <Input
      {...inputProps}
      value={value}
      onChange={(e) => setValue(e.target.value)}
    />
  );
};

DebounceInput.id = 'Input';
export default DebounceInput;
